import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const StockWarningDialog = ({ stockWarning, onCancel, onConfirm, saving }) => (
  <AlertDialog open={!!stockWarning} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <AlertDialogContent data-testid="stock-warning-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2 text-amber-600">
          <AlertTriangle className="w-5 h-5" /> Insufficient stock
        </AlertDialogTitle>
        <AlertDialogDescription>
          These sizes are ordered above their available stock. The order will still be saved and the stock reserved.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <div className="max-h-60 overflow-y-auto rounded-md border divide-y text-sm">
        {(stockWarning?.warnings || []).map((w, i) => (
          <div key={i} className="flex items-center justify-between px-3 py-2" data-testid={`stock-warning-row-${i}`}>
            <span className="font-medium text-gray-700">{w.label}</span>
            <span className="text-xs whitespace-nowrap">
              <span className="text-red-600 font-semibold">Order {w.ordered}</span>
              <span className="text-gray-400"> / Avail {w.available}</span>
            </span>
          </div>
        ))}
      </div>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel} data-testid="stock-warning-cancel">Go back</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} disabled={saving} className="bg-amber-600 hover:bg-amber-700" data-testid="stock-warning-confirm">
          {saving ? 'Saving...' : 'Reserve & Continue'}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default StockWarningDialog;
